import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { ConversationDetailsLayout } from 'components/conversationsOverview/components/ConversationDetails/ConversationDetailsLayout';
import { CHANNEL_ICON } from 'components/conversationsOverview/components/ConversationDetails/channelIcon';
export const RequesterAvatar = (props) => {
    const { metaConversation: { requester, conversation: { initial_channel: channel }, }, layout, } = props;
    const isCollapsedSidebar = layout === ConversationDetailsLayout.SidebarCollapsed;
    const channelIcon = channel ? CHANNEL_ICON[channel] : null;
    const avatar = isCollapsedSidebar ? (channelIcon ? (_jsx(Avatar, { icon: channelIcon })) : (_jsx(Avatar, { user: requester !== null && requester !== void 0 ? requester : null }))) : (_jsx(Avatar, { user: requester !== null && requester !== void 0 ? requester : null }));
    if (layout === ConversationDetailsLayout.Overview && (requester === null || requester === void 0 ? void 0 : requester.id)) {
        return (_jsx(Link, Object.assign({ to: `/conversations?requester=${requester.id}` }, { children: avatar })));
    }
    return avatar;
};
